import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  type EventTypes,
  EventTypeTags,
  ListEventTypes,
} from '@/domains/traffic-monitoring/constants/listEvent.constant';
import { useColorStore } from '@/store/colorStore';

interface BubbleEventProps {
  eventTypes: EventTypes;
}

const BubbleEvent = ({ eventTypes }: BubbleEventProps) => {
  const { t } = useTranslation();
  const { NEWCOLOR } = useColorStore();
  const EventType = ListEventTypes[eventTypes];
  const label = EventTypeTags[eventTypes]
    ? t(EventTypeTags[eventTypes])
    : eventTypes.replace(/_/g, ' ');
  return (
    <span
      className="w-fit px-3 py-2 text-white rounded-full title2 uppercase"
      style={{
        backgroundColor: NEWCOLOR[EventType.color],
      }}
    >
      {label}
    </span>
  );
};

export default BubbleEvent;
